import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9pxh3wj37: FaireBrandEntity = {
  token: "b_a9pxh3wj37",
  type: "brand",
  name: "ripple⁺ home",
  avatarUrl:
    "https://cdn.faire.com/fastly/189ee3dda62c5c09a71ba2a7b78e2ec9ba9e6a8b3219a5f318d6d21e9fc71860.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/10f34a4abdd1ffd71ea2bc8ec010a0484f94b47e7c37217f4039264c584e9b81.png",
  logoUrl:
    "https://cdn.faire.com/fastly/189ee3dda62c5c09a71ba2a7b78e2ec9ba9e6a8b3219a5f318d6d21e9fc71860.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/10f34a4abdd1ffd71ea2bc8ec010a0484f94b47e7c37217f4039264c584e9b81.png",
  location: "Sheridan, WY, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Ripple+ is a young innovative brand breaking boundaries in wellness. We offer unique aromatherapy and wellness solutions ranging from on-the-go aromatherapy diffusers to homeware fragrance! Our products combine a sleek aesthetic appeal with rich aromatic experiences, transforming everyday wellness routines into immersive sensory journeys.\n \nRipple+ has been making waves since 2019, thanks to our exciting partnerships. With ripple+ expanding its reach to new destinations, more and more people are now able to experience the benefits of our wellness products and enjoy a healthier lifestyle while on the go. Our dynamic community of stockists stretches across 12 countries. We proudly collaborate with over 3,000 locations, the majority of whom share our brand values, providing tangible touchpoints for our dedicated community members.\n \nNotable stockists have included the likes of Neiman Marcus, John Bell and Croyden, Harrods, Selfridges, Superdrug, and Players Cafe; and this only marks the beginning! Leveraging the power of our social media community, boasting over 153,000 followers on Instagram and 410,000 followers on TikTok, we've successfully engaged our audience and driven consumers to various retail locations. This dynamic online presence has played a pivotal role in our brand's visibility and market reach.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.238Z",
    importedBy: "entity-db-cli",
  },
};
